import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2039b6a8"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2039b6a8&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2039b6a8')) {
      api.createRecord('2039b6a8', component.options)
    } else {
      api.reload('2039b6a8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2039b6a8", function () {
      api.rerender('2039b6a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appSetting/routine/download/index.vue"
export default component.exports